module.exports = __webpack_public_path__ + "static/4x_finance_onboarding_3-d3d43cac50138ed5497e5faafdb9cf67.png";